import { useEffect, useRef, useState } from 'react'
import { Customer } from '@components/account/types'

export function useWaitForUserProfile(
  profile: Customer | null,
  maxAttempts = 10,
  interval = 200
) {
  const [isReady, setIsReady] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const profileRef = useRef<Customer | null>(profile)

  useEffect(() => {
    profileRef.current = profile
  }, [profile])

  useEffect(() => {
    let attempts = 0
    let cancelled = false

    const check = () => {
      const currentProfile = profileRef.current
      if (cancelled) return

      if (currentProfile) {
        setIsReady(true)
        setIsLoading(false)
      } else if (++attempts >= maxAttempts) {
        setIsReady(false)
        setIsLoading(false)
      } else {
        setTimeout(check, interval)
      }
    }

    check()

    return () => {
      cancelled = true
    }
  }, [maxAttempts, interval])

  return { isReady, isLoading }
}
